import { render, staticRenderFns } from "./CsDashboards.vue?vue&type=template&id=4ba06d9a&scoped=true&"
import script from "./CsDashboards.vue?vue&type=script&lang=js&"
export * from "./CsDashboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba06d9a",
  null
  
)

export default component.exports